import { useAppContext } from "../../../_context";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "next/image";
import StyledBulletList from "../../StyledBulletList";
import Button from "../../Misc/Button";

const WaitingList = () => {
  const [{ tx }] = useAppContext();
  const bulletList = [
    tx["Special preview access to club services on the RacketPal app"],
    tx["Exclusive free trial of all premium features"],
    tx["No commitment or tie-in"],
    tx["Expert support and guidance from the RacketPal team"],
  ];
  const contentSection = (
    <div className="content-section position-relative">
      <div className="position-relative">
        <h2>{tx["Join the waiting list now and you’ll benefit from:"]}</h2>
        <StyledBulletList
          bulletList={bulletList}
          className="mb-3"
          bulletColor="primary"
          tickColor="white"
        />
        <Button href="/contact?reason=clubs_waiting_list">
          {tx["Join waiting list"]}
        </Button>
      </div>
    </div>
  );

  return (
    <section className="waiting-list-section position-relative mw-1920 mx-auto section-padding-bottom">
      <Container>
        <Row>
          <Col md={8} lg={7} className="d-flex align-items-end">
            <div className="w-100 ">
              <div className="pins-container mb-6 mb-md-0">
                <Image
                  src="/img/clubs/pins.png"
                  width={425}
                  height={343}
                  unoptimized={true}
                />
              </div>
              <div className="d-none d-md-block">{contentSection}</div>
            </div>
          </Col>
          <Col md={4} lg={5} className="d-md-flex align-items-center">
            <div className="waiting-list-image-container">
              <Image
                src="/img/clubs/waiting-list.png"
                width={463}
                height={826}
                unoptimized={true}
              />
            </div>
            <div className="d-md-none">{contentSection}</div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WaitingList;
